import { render, staticRenderFns } from "./InternalShippingDocumentsPage.vue?vue&type=template&id=34b104c7&scoped=true"
import script from "./InternalShippingDocumentsPage.vue?vue&type=script&lang=js"
export * from "./InternalShippingDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b104c7",
  null
  
)

export default component.exports